var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01411 12.8633C8.82177 12.4154 8.47054 12.0446 8.02058 11.8144C7.57063 11.5843 7.04995 11.509 6.54772 11.6016C6.04549 11.6942 5.59296 11.9488 5.26764 12.3219C4.94233 12.695 4.76447 13.1633 4.76453 13.6466C4.76453 13.8606 4.71801 14.0722 4.62784 14.2685C4.53767 14.4648 4.40578 14.6415 4.24035 14.7877C4.07492 14.9338 3.87946 15.0464 3.6661 15.1183C3.45274 15.1901 3.22603 15.2199 3 15.2056C3.36353 15.8021 3.92537 16.2686 4.59831 16.5326C5.27125 16.7966 6.01765 16.8433 6.72161 16.6656C7.42558 16.4879 8.04775 16.0957 8.49152 15.5498C8.9353 15.0039 9.17586 14.3349 9.17586 13.6466C9.17586 13.3695 9.11851 13.1049 9.01411 12.8633ZM9.01411 12.8633C9.8883 12.5819 10.7244 12.2043 11.505 11.7383C12.8993 10.9062 14.0919 9.80648 15.0069 8.51048L17.8566 4.47298C17.9658 4.3192 18.015 4.1344 17.996 3.95013C17.9769 3.76586 17.8907 3.59355 17.7521 3.46263C17.6135 3.33171 17.4311 3.2503 17.236 3.2323C17.0409 3.2143 16.8453 3.26084 16.6825 3.36395L12.4079 6.05631C11.0356 6.9203 9.87106 8.04654 8.98985 9.36326M7.79732 11.7209C8.09524 10.8934 8.49551 10.1021 8.98985 9.36326M8.98985 9.36326C10.1088 9.83581 11.004 10.6821 11.5043 11.739",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.bdd46aa7a7900ff649456df53a10fb03.svg";
export { ForwardRef as ReactComponent };